import { Injectable, OnDestroy } from '@angular/core';
import { CmpsDialog } from '@cmps/ng-uikit';

import {
    TranscriptImportHook,
    TranscriptImportHookService,
    WillImportContext,
} from '../../teams-call';

import { TranscriptImportFocusDialogData } from './model/transcript-import-focus-dialog-data.model';
import { TranscriptImportFocusDialogComponent } from './transcript-import-focus-dialog.component';

@Injectable({ providedIn: 'root' })
export class CoachingTranscriptImportHookService
    implements OnDestroy, TranscriptImportHook
{
    constructor(
        private readonly _hookService: TranscriptImportHookService,
        private readonly _dialog: CmpsDialog,
    ) {
        this._hookService.register(this);
    }

    ngOnDestroy(): void {
        this._hookService.unregister(this);
    }

    async tiWillImport(context: WillImportContext): Promise<boolean> {
        const data: TranscriptImportFocusDialogData = {
            userId: context.userId,
            context: context.context,
        };
        const ref = this._dialog.open<
            TranscriptImportFocusDialogComponent,
            TranscriptImportFocusDialogData,
            boolean
        >(TranscriptImportFocusDialogComponent, {
            movable: true,
            data,
        });
        return await ref.result.toPromise();
    }
}
